import { render, staticRenderFns } from "./OsInputCheckbox.vue?vue&type=template&id=76199907&scoped=true"
import script from "./OsInputCheckbox.vue?vue&type=script&lang=ts"
export * from "./OsInputCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./OsInputCheckbox.vue?vue&type=style&index=0&id=76199907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76199907",
  null
  
)

export default component.exports